import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { BasicInformatioTableDef } from '../../../../../containers/SingleSheetV2/table/model'
import {
  PROJECT_BASIC_INFORMATION_HEADER_ID,
  ProjectCellOptions,
  useProjectCellDefs,
} from './cellDefs'

// プロジェクト情報画面（プロジェクトメニュー）の基本情報テーブル。
// 更新のみで作成モードが無いため、編集可否は固定（code・採番形式は読取専用、status は編集可）。
// 登録画面には無い GitHub レビュワー同期項目を持つ。
export const useProjectInformationBasicInformationTableDef = (
  options: ProjectCellOptions
): BasicInformatioTableDef => {
  const intl = useIntl()
  const cells = useProjectCellDefs(options, {
    code: false,
    status: true,
    wbsItemCodeFormat: false,
  })
  return useMemo<BasicInformatioTableDef>(
    () => ({
      tables: [
        {
          header: {
            externalId: PROJECT_BASIC_INFORMATION_HEADER_ID,
            label: intl.formatMessage({ id: 'projectV2.basicInformation' }),
          },
          rows: [
            [cells.code],
            [cells.iconUrl],
            [cells.displayName],
            [cells.officialName],
            [cells.businessClient],
            [cells.division],
            [cells.projectManager],
            [cells.status],
            [cells.scheduledDate],
            [cells.wbsItemCodeFormat],
            [cells.mainEmail],
            [cells.githubReviewerSyncEnabled],
          ],
        },
      ],
    }),
    [intl, cells]
  )
}
